import Vue from "vue";
import axios from "axios";
import { getCookies } from "../utils";
class NetworkService {
  static uri(path) {
    //call api from env
    const ROOT_URL = process.env.VUE_APP_API_URL;
    return ROOT_URL + path;
  }

  static request(endpoint, params) {
    let headers = !NetworkService.getToken()
      ? NetworkService.headers()
      : NetworkService.headerWithToken();

    let options = Object.assign(
      {},
      {
        url: endpoint,
        headers,
      },
      params
    );

    return axios(endpoint, options).then(NetworkService.handleResponse);
  }

  //init request with token
  static headerWithToken() {
    return Object.assign(NetworkService.headers(), {
      Authorization: "Bearer " + NetworkService.getToken(),
    });
  }

  static headers() {
    return {
      "Content-Type": "application/json",
    };
  }

  static post(endpoint, payload, options) {
    options = Object.assign({}, options, {
      data: JSON.stringify(payload),
      method: "POST",
    });

    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static get(endpoint, options) {
    options = Object.assign({}, options, {
      method: "GET",
      data: null,
    });
    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static delete(endpoint, options) {
    options = Object.assign({}, options, {
      method: "DELETE",
    });
    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static put(endpoint, payload, options) {
    if (options == null) {
      options = Object.assign({}, options, {
        data: JSON.stringify(payload),
        method: "PUT",
      });
    } else {
      options.method = "PUT";
      options.data = payload;
    }

    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static handleResponse(res) {
    const { status, data } = res;

    return status >= 200 && status <= 300 ? data : data;
  }

  static handleError(error) {
    const { status, data } = error;

    const errs = error && error.response ? error.response.data : error;

    return errs;
  }

  static getToken() {
    return getCookies("token");
    // return sessionStorage.getItem("token");
    // return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdGF0ZUlEIjoxLCJVc2VyVHlwZUlEIjoyLCJBY2Nlc3NMZXZlbElEIjoxLCJUZW5hbnRJRCI6IjdhMTY1YjA5LTZlMzMtNDBkNC1iNzA3LTU4M2IzOThiYTkzNiIsIlVzZXJJRCI6ImM2ZjEzMzM5LWRkMzMtNDA3Yi1iMGYxLTBmZWI2N2Q3NjY5OCIsIkRpc3RyaWN0SUQiOjEsIkFjY2Vzc0ZsYWciOnRydWUsIlVzZXJUeXBlIjoiQWRtaW4iLCJBY2Nlc3NMZXZlbCI6InJvb3QiLCJleHAiOjE3NzcxMTI5MTN9.yEMA_sCjHN3ZjUzv-dZnINNJlt53SjsA4uK7uWeEyL0";
  }
}

export default NetworkService;
